<template>
    <div id="website">
      <full-page :options="options" id="fullpage" ref="fullpage">
        <!-- 轮播图 -->
        <div class="section">
          <swiper></swiper>
        </div>
        <!-- 大翻页面板 -->
        <div class="section">
          <section2 :curIndex="curIndex" ref="section2"></section2>
        </div>
        <div class="section">
          <section3></section3>
        </div>
        <div class="section">
          <section4></section4>
        </div>
      </full-page>
    </div>
  </template>
  
  <script>
  import Swiper from "./components/Swiper-black-vip";
  
  // import Section2 from "./section2.vue";
  import Section2 from "./black-vip-zone-section2.vue";
  // import Section2 from "./section2-copy.vue";
  import Section3 from "./black-vip-zone-section3.vue";
  import Section4 from "./black-vip-zone-section4.vue";
  export default {
    name: "Home",
    components: {
      Swiper,
      Section2,
      Section3,
      Section4,
    },
  
    data() {
      return {
        curIndex: 0,
        options: {
          licenseKey: "YOUR_KEY_HERE",
          afterLoad: this.afterLoad,
          scrollOverflow: true,
          scrollBar: false,
          menu: "#menu",
          navigation: true,
          navigationColor: "#fff",
          anchors: ["page1", "page2", "page3", "page4", "page5"],
          // sectionsColor: [
          //   "#41b883",
          //   "#ff5f45",
          //   "#fff",
          //   "#fec401",
          //   "#1bcee6",
          //   "#ee1a59",
          //   "#2c3e4f",
          //   "#ba5be9",
          //   "#b4b8ab",
          // ],
        },
        swiperOptions: {
          pagination: {
            el: ".swiper-pagination", //与slot="pagination"处 class 一致
            clickable: true, //轮播按钮支持点击
          },
        },
      };
    },
    mounted() {
      window.onresize = () => {
        this.$refs.fullpage.build();
      };
    },
    created() {
      document.title = "INDIBA中国官方网站";
    },
    methods: {
      afterLoad(pre, cur) {
        console.log("After load", pre, cur);
        this.curIndex = cur.index;
        if (this.curIndex === 1) {
          // this.$refs.section2.init(this.curIndex, pre.index);
        }
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  body,
  #website {
    min-width: 1280px;
    @font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    user-select: none;
    box-sizing: border-box;
  }
  
  .page1 {
    position: relative;
  }
  </style>
  